// extracted by mini-css-extract-plugin
module.exports = {"btn":"index_btn_2y7xR","txt":"index_txt_1OjW3"};